import { message } from "antd";
import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class DetailedJobStore {
  loading = false;
  total = 0;
  detailedJobData = [];
  tripData = [];
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      loading: observable,
      total: observable,
      detailedJobData: observable,
      tripData: observable,
      loadData: action,
      loadTripData: action,
      exportExcel: action,
      exportpdf: action
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    vehicleId,
    driverId,
    filterBy,
    fromDate,
    toDate,
    offset,
    limit,
    pageNo,
    hasInvoice,
  }) {
      this.loading = true;
      var postData = {
        companyId: companyId,
        vehicleId: vehicleId,
        driverId: driverId,
        filterBy: filterBy,
        fromDate: fromDate,
        toDate: toDate,
        offset: offset,
        limit: limit,
        pageNo: pageNo,
        hasInvoice: hasInvoice,
      };

      var response = await postApi.getClient('report').post("/fleet_report/detailedJobReport", postData);
      this.detailedJobData = response?.data?.data?.dailytripreport;
      this.total = parseInt(response?.data?.data?.TotalCount);
      this.loading = false;
  }

  async loadTripData({ vehicleId, fromDate, toDate, status }) {
    this.loading = true;
    var postData = {
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
      driverId: null,
      status: status,
    };

    var response = await postApi.getClient('report').post("/fleet_report/getDailyTripSheet", postData);

    this.tripData = response?.data?.data;
    this.loading = false;
  }

  async exportExcel(getData) {

      getData = { ...getData, language: "english" }
      
      try {
          var response = await postApi.getClient().post("/fleet_report/detailedJobReport/download/excel", getData, {
              responseType: "blob",
          });
      
          const blob = new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
      
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Detailed Job Report.xlsx";
      
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
    
      } catch (error) {
          message.error("Failed to download the report. Please try again.")
      }

  }

  async exportpdf(getData) {

      getData = { ...getData, language: "english" }

      try {
          var response = await postApi.getClient().post("/fleet_report/detailedJobReport/download/pdf", getData, {
              responseType: "blob",
          });
      
          const blob = new Blob([response.data], {
              type: 'application/pdf'
          });
      
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Detailed Job Report.pdf";
      
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
      } catch (error) {
          message.error("Failed to download the report. Please try again.")
      }

  }

}

export default DetailedJobStore;
